<style scoped>
  .card-padding {
    padding: 25px;
  }
  .special-header {
    background-color: #DEE3E4;
  }
</style>

<template>
  <v-card v-if="isUserAdmin()">
    <v-card-title class="special-header">
      <p class="headline text--primary mt-3 mb-3 ml-3">{{ title }}</p>
    </v-card-title>
    <v-card-text>
      <v-container fluid class="card-padding">
        <v-layout row wrap>
          <v-flex
            v-for="group in user.groups"
            :key="group"
            xs4
          >
            {{ group }}
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    display: false,
    title: 'Group Associations',
  }),
  methods: {
    isUserAdmin() {
      return this.user.roles.includes('users_administrator') || this.user.roles.includes('admin');
    },
  },
  computed: {
    user: vm => vm.$store.getters.user,
  },
};
</script>
